import classNames from 'classnames'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { AsideNavigation } from '@components/AsideNavigation'

import { useActions } from '@hooks/useActions'

import { ReactComponent as DecoBook } from '@assets/img/static/deco-book.svg'
// import { ReactComponent as AsideLogo } from '@assets/img/static/aside-logo.svg'
import { ReactComponent as Logo } from '@assets/img/static/logo-lg.svg'
import { useAppSelector } from '@store/hooks'

import type { AsideProps } from './Aside.props'

export function Aside({ variant = 'main' }: AsideProps) {
  const { asideShow } = useAppSelector((state) => state.global)

  const { asideToggleShow } = useActions()

  const { pathname } = useLocation()

  return (
    <aside
      className={classNames(
        'aside',
        {
          'aside--main': variant === 'main',
          'aside--static': variant === 'static',
          'aside--mush': variant === 'mush',
        },
        { 'aside--hide': !asideShow },
      )}
    >
      <div className="aside__wrapper">
        {variant === 'main' && (
          <button
            className="aside__btn"
            onClick={() => asideToggleShow()}
            id="aside-btn"
          >
            <svg className="aside__btn-svg">
              <use href="/img/sprite.svg#aside-arrows"></use>
            </svg>
          </button>
        )}

        <div className="aside__top">
          <Link
            to="/"
            className={classNames({
              'aside--mush__logo': variant === 'mush',
              aside__logo: variant !== 'mush',
            })}
          >
            {asideShow || pathname.includes('sign-up') || pathname.includes('moderating') ? <Logo /> : <LogoForCollapsedAside />}
          </Link>

          {variant === 'mush' && <DecoBook className="aside--mush__deco" />}
        </div>
        {variant === 'main' && <AsideNavigation />}
      </div>
    </aside>
  )
}

/* eslint-disable */
const LogoForCollapsedAside = () => (
  <svg
    width="20"
    height="7"
    viewBox="0 0 20 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12654_2986)">
      <path
        d="M13.1367 0.132324H13.9302V4.54424H16.1124V0.132324H16.9059V4.54424H19.088V0.132324H19.8816V5.29015H13.1367V0.132324Z"
        fill="#FFC300"
      />
      <path
        d="M9.13565 5.40088C8.45323 3.62341 7.95862 2.4252 7.6518 1.80627C7.44018 1.39893 7.26297 1.12122 7.12016 0.973095C6.9826 0.824965 6.83977 0.750902 6.69164 0.750902C6.63346 0.750902 6.58586 0.753548 6.54883 0.758837L6.76307 0.0526133C6.83714 0.0367435 6.90326 0.0288086 6.96143 0.0288086C7.17305 0.0288086 7.3582 0.0817096 7.5169 0.187512C7.68089 0.293314 7.84224 0.47053 8.00094 0.719163C8.15964 0.967809 8.33685 1.31695 8.5326 1.76658C8.84471 2.47546 9.17268 3.35362 9.51654 4.40106L9.60383 4.14713C9.92122 3.16846 10.2069 2.37494 10.4608 1.76658C10.6513 1.32224 10.8232 0.975725 10.9766 0.727098C11.13 0.478465 11.2861 0.301249 11.4448 0.195446C11.6035 0.0896444 11.7833 0.0367434 11.9844 0.0367434C12.0161 0.0367434 12.0743 0.0420352 12.1589 0.0526133L12.3732 0.758837C12.3361 0.753548 12.2885 0.750902 12.2303 0.750902C12.0769 0.750902 11.9288 0.822319 11.786 0.965152C11.6484 1.10799 11.4845 1.38041 11.294 1.78247C11.0348 2.32734 10.6222 3.39065 10.0561 4.97237L9.46099 6.88474H8.67542L9.13565 5.40088Z"
        fill="#FFC300"
      />
      <path
        d="M0.684363 0.132324H1.92224C2.28196 2.24306 2.55705 3.74015 2.7475 4.62358C2.94323 5.50174 3.08604 5.94082 3.17599 5.94082C3.26591 5.94082 3.4061 5.50174 3.59654 4.62358C3.79227 3.74015 4.07 2.24306 4.42974 0.132324H5.66761L6.22307 5.29015H5.41367L4.98518 0.997257C4.96932 1.10835 4.95081 1.22736 4.92964 1.35434C4.90849 1.47601 4.88732 1.60562 4.86617 1.74314C4.62281 3.21379 4.43237 4.27444 4.29485 4.92512C4.16258 5.57051 4.00917 6.0572 3.83461 6.38517C3.66531 6.71317 3.4405 6.87715 3.16011 6.87715C2.87974 6.87715 2.65227 6.71317 2.4777 6.38517C2.30842 6.0572 2.155 5.57051 2.01746 4.92512C1.88521 4.27444 1.69741 3.21379 1.45407 1.74314C1.43291 1.60562 1.41175 1.47601 1.39059 1.35434C1.36943 1.22736 1.35091 1.10835 1.33504 0.997257L0.906546 5.29015H0.128906L0.684363 0.132324Z"
        fill="#FFC300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0215 0.0170898H14.0451V4.429H15.9972V0.0170898H17.0208V4.429H18.9728V0.0170898H19.9964V5.40501H13.0215V0.0170898ZM19.0879 4.54405H16.9057V0.132139H16.1122V4.54405H13.9301V0.132139H13.1365V5.28996H19.8814V0.132139H19.0879V4.54405Z"
        fill="#FFC300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13609 5.40118C8.45367 3.62371 7.95906 2.42551 7.65224 1.80657C7.44063 1.39923 7.26341 1.12152 7.12057 0.973396C6.98305 0.825266 6.84021 0.751203 6.69208 0.751203C6.68518 0.751203 6.67844 0.751242 6.67185 0.751315C6.62276 0.751867 6.5819 0.754476 6.54924 0.75914L6.76349 0.0529141C6.83755 0.0370443 6.9037 0.0291094 6.96187 0.0291094C7.17349 0.0291094 7.35865 0.0820104 7.51734 0.187813C7.68133 0.293615 7.84268 0.470831 8.00138 0.719463C8.16008 0.968109 8.33729 1.31725 8.53302 1.76689C8.82706 2.43467 9.13516 3.25269 9.45734 4.22092C9.47716 4.2805 9.49706 4.34064 9.51698 4.40136L9.60427 4.14743C9.92167 3.16876 10.2073 2.37524 10.4612 1.76689C10.6517 1.32254 10.8236 0.976026 10.977 0.727398C11.1304 0.478766 11.2865 0.301549 11.4452 0.195747C11.6039 0.0899452 11.7838 0.0370442 11.9848 0.0370442C12.0165 0.0370442 12.0747 0.042336 12.1594 0.0529141L12.3736 0.75914C12.341 0.754476 12.3001 0.751867 12.251 0.751315C12.2444 0.751242 12.2377 0.751203 12.2308 0.751203C12.0774 0.751203 11.9292 0.82262 11.7864 0.965453C11.6489 1.10829 11.4849 1.38071 11.2945 1.78277C11.0352 2.32764 10.6226 3.39095 10.0566 4.97269L9.46143 6.88504H8.67586L9.13609 5.40118ZM10.1657 5.00918L9.54612 7.00009H8.51971L9.0144 5.40519C8.33956 3.64871 7.85164 2.46808 7.54964 1.85866C7.33867 1.45264 7.16799 1.18832 7.03776 1.05324L7.03701 1.05246L7.03628 1.05168C6.91227 0.918135 6.79786 0.86626 6.69208 0.86626C6.63669 0.86626 6.59508 0.868813 6.56552 0.873031L6.38672 0.898578L6.6731 -0.0453724L6.7394 -0.0595781C6.81914 -0.0766693 6.89359 -0.0859375 6.96187 -0.0859375C7.19331 -0.0859375 7.40096 -0.0278281 7.58044 0.0916094C7.76333 0.209813 7.9351 0.401797 8.09836 0.657565C8.26172 0.9135 8.44169 1.26884 8.63846 1.72087C8.91953 2.35923 9.21273 3.13251 9.51818 4.04014C9.82677 3.09277 10.1058 2.31993 10.3551 1.72259L10.3553 1.72207L10.3555 1.72157C10.547 1.27491 10.7214 0.922536 10.8791 0.666987C11.0371 0.411031 11.2036 0.218576 11.3814 0.100021C11.5601 -0.0190781 11.7623 -0.0780026 11.9848 -0.0780026C12.0247 -0.0780026 12.0896 -0.0717501 12.1736 -0.0612449L12.2478 -0.0519766L12.5361 0.898578L12.3573 0.873031C12.3278 0.868813 12.2862 0.86626 12.2308 0.86626C12.1169 0.86626 11.9966 0.91824 11.8685 1.04603C11.7452 1.17449 11.5881 1.43157 11.3984 1.83202L11.3983 1.8322C11.1421 2.37082 10.7315 3.42808 10.1657 5.00918Z"
        fill="#FFC300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.580237 0.0170898H2.01854L2.03485 0.112811C2.39452 2.22324 2.66922 3.71804 2.85909 4.59884C2.95669 5.03679 3.04036 5.36163 3.11003 5.57574C3.13404 5.6496 3.15568 5.70796 3.17474 5.7522C3.19349 5.70806 3.21469 5.64988 3.23818 5.57634C3.30656 5.36218 3.38828 5.0372 3.48331 4.59903L3.48336 4.59876L3.48341 4.59853C3.67849 3.71811 3.95581 2.2235 4.31552 0.112811L4.33182 0.0170898H5.77013L6.35036 5.40501H5.30875L4.95779 1.88892C4.7245 3.29371 4.54076 4.314 4.40667 4.94843C4.27372 5.59702 4.11781 6.096 3.93573 6.43837C3.75401 6.79009 3.49643 6.99202 3.15932 6.99202C2.82247 6.99202 2.56236 6.79043 2.37534 6.43905L2.37499 6.43843L2.37466 6.43778C2.19837 6.09621 2.04242 5.59778 1.90414 4.94892L1.90402 4.9484L1.90391 4.94785C1.77507 4.31392 1.59401 3.29389 1.36084 1.88892L1.00988 5.40501H0L0.580237 0.0170898ZM1.33424 0.997072C1.35011 1.10817 1.36862 1.22718 1.38978 1.35416C1.39493 1.38374 1.40007 1.41376 1.40522 1.44429C1.42123 1.53931 1.43725 1.63887 1.45327 1.74296C1.69661 3.21361 1.88441 4.27426 2.01666 4.92494C2.1542 5.57033 2.30761 6.05702 2.47689 6.38499C2.65146 6.71298 2.87893 6.87697 3.15932 6.87697C3.43969 6.87697 3.66451 6.71298 3.8338 6.38499C4.00836 6.05702 4.16177 5.57033 4.29404 4.92494C4.43156 4.27426 4.622 3.21361 4.86536 1.74296C4.88138 1.63887 4.8974 1.53931 4.91341 1.44429C4.91854 1.41376 4.9237 1.38374 4.92883 1.35416C4.95 1.22718 4.96852 1.10817 4.98437 0.997072L5.41289 5.28996H6.22227L5.6668 0.132139H4.42893C4.06919 2.24288 3.79148 3.73996 3.59576 4.6234C3.40531 5.50155 3.2651 5.94064 3.17518 5.94064C3.08526 5.94064 2.94242 5.50155 2.74669 4.6234C2.55624 3.73996 2.28116 2.24288 1.92143 0.132139H0.68356L0.128103 5.28996H0.905742L1.33424 0.997072ZM3.12719 5.84153C3.12661 5.84205 3.1263 5.84236 3.1263 5.84238C3.1263 5.84241 3.12661 5.84215 3.12719 5.84153ZM3.22372 5.84218C3.22372 5.84218 3.22341 5.84192 3.22281 5.84126C3.22344 5.84184 3.22375 5.84215 3.22372 5.84218Z"
        fill="#FFC300"
      />
    </g>
    <defs>
      <clipPath id="clip0_12654_2986">
        <rect
          width="20"
          height="6.95652"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
